export const selectMessageTemplateState = (state) => state.messageTemplate;
